export default "__VITE_ASSET__DpkpLuAh__"